<template>
  <div class="container">
    <div class="container-tags">
      <div v-for="(items, index) in item" :key="index">
        <button type="button" class="btn tags textoverflow">{{ items.name }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item']
}
</script>

<style lang="scss" scoped>
.container-tags {
  display: flex;
  max-width: 100%;
  overflow: scroll;
}

::-webkit-scrollbar {
  display: none;
}
</style>
